import { createRouter, createWebHistory } from '@ionic/vue-router';
import routes from '@/routes';

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

router.onError((error) => {
  const staleChunk = /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed/i
    .test(error.message);
  const retried = sessionStorage.getItem('router:stale-chunk-reload');

  if (staleChunk && !retried) {
    sessionStorage.setItem('router:stale-chunk-reload', '1');
    window.location.reload();
  }
});

router.afterEach(() => {
  sessionStorage.removeItem('router:stale-chunk-reload');
});

export default router;
